var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 890.45 535.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".an{fill:url(#u);}.ao{fill:url(#t);}.ap{fill:url(#v);}.aq{fill:url(#p);}.ar{fill:url(#o);}.as{fill:url(#s);}.at{fill:url(#q);}.au{fill:url(#r);}.av{fill:url(#i);}.aw{fill:url(#h);}.ax{fill:url(#k);}.ay{fill:url(#j);}.b`{fill:url(#m);}.ba{fill:url(#l);}.bb{fill:url(#n);}.bc{fill:url(#x);}.bd{fill:url(#w);}.be{fill:url(#y);}.bf{fill:url(#aa);}.bg{fill:url(#ag);}.bh{fill:url(#ab);}.bi{fill:url(#ah);}.bj{fill:url(#ai);}.bk{fill:url(#ad);}.bl{fill:url(#aj);}.bm{fill:url(#ae);}.bn{fill:url(#af);}.bo{fill:url(#a`);}.bp{fill:url(#al);}.bq{fill:url(#am);}.br{fill:url(#ac);}.bs{fill:url(#ak);}.bt{fill:#4e9ed7;}.bu{fill:url(#g);}.bu,.bv,.bw,.bx{isolation:isolate;}.bv{fill:url(#f);}.bw{fill:url(#e);}.bx{fill:url(#d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 608.67,
    y1: 99.27,
    x2: 292.19,
    y2: 99.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ec3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5cc0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#57b6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4ea7cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4191bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367db5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 308.64,
    y1: 67.22,
    x2: 489.59,
    y2: 67.22,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 370.17,
    y1: 92.36,
    x2: 459.31,
    y2: 92.36,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 420.59,
    y1: 106.57,
    x2: 459.17,
    y2: 106.57,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 421.67,
    y1: 99.27,
    x2: 615.6,
    y2: 99.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ec3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#50abcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4496c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3c88ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#377fb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367db5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 281.78,
    y1: 216.8,
    x2: 598.26,
    y2: 216.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6b1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f5aaa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f298a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ee7ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee79a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 400.86,
    y1: 248.85,
    x2: 581.81,
    y2: 248.85,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 431.14,
    y1: 223.72,
    x2: 520.28,
    y2: 223.72,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 431.28,
    y1: 209.5,
    x2: 469.87,
    y2: 209.5,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -932.98,
    y1: -1237.89,
    x2: -739.06,
    y2: -1237.89,
    gradientTransform: "translate(-464.18 -1021.14) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6b1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f29ba3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f088a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ee7ca6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee79a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0,
    y1: 466.83,
    x2: 121.35,
    y2: 466.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1e2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 407.21,
    y1: 519.86,
    x2: 337.08,
    y2: 449.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1e2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#171919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 427.32,
    y1: 466.83,
    x2: 549.43,
    y2: 466.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1c1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#161818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 750.68,
    y1: 518.41,
    x2: 681.32,
    y2: 449.05,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 2076.54,
    y1: 533.49,
    x2: 2076.54,
    y2: 428.25,
    gradientTransform: "translate(2124.92) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1f2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#171919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 100.42,
    y1: 521.52,
    x2: 206.73,
    y2: 460.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1e2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1d2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#161818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 132.87,
    y1: 530.15,
    x2: 132.87,
    y2: 465.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1c1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 99.07,
    y1: 518.83,
    x2: 160.62,
    y2: 518.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1d1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#191b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 144.73,
    y1: 526.26,
    x2: 164.38,
    y2: 506.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 130.7,
    y1: 505.78,
    x2: 168.78,
    y2: 467.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 173.2,
    y1: 533.78,
    x2: 173.2,
    y2: 440.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#1f2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1d2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#161919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 551.59,
    y1: 522.15,
    x2: 657.9,
    y2: 460.77,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a`",
    x1: 584.04,
    y1: 530.78,
    x2: 584.04,
    y2: 466.09,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 550.24,
    y1: 519.46,
    x2: 611.79,
    y2: 519.46,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 595.9,
    y1: 526.89,
    x2: 615.55,
    y2: 507.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 581.87,
    y1: 506.41,
    x2: 619.95,
    y2: 468.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 624.37,
    y1: 534.41,
    x2: 624.37,
    y2: 441.01,
    xlinkHref: "#x"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 246.99,
    y1: 510.83,
    x2: 250.19,
    y2: 507.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#171919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 208.43,
    y1: 466.83,
    x2: 327.43,
    y2: 466.83,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 285.76,
    y1: 533.78,
    x2: 285.76,
    y2: 477.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1c1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#161818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 771.45,
    y1: 466.83,
    x2: 890.45,
    y2: 466.83,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 848.78,
    x2: 848.78,
    xlinkHref: "#ag"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 369.14,
    y1: 433.48,
    x2: 369.14,
    y2: 535.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1c1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 713.39,
    y1: 433.57,
    x2: 713.39,
    y2: 535.7,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 529.56,
    y1: 464.48,
    x2: 484.41,
    y2: 419.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1e2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#181b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 525.21,
    y1: 525.2,
    x2: 484.79,
    y2: 484.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1e2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#202323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M296.9,33.54c12.23-4.73,116.79-47.66,196.99-28.75,35.02,8.25,65.4,28.29,81.43,68.45,3.78,9.47,7.51,19.45,11.16,29.78,3.19,9.03,6.32,18.32,9.36,27.76h0c2.98,9.3,5.87,18.73,8.64,28.2,1.43,4.86,2.82,9.74,4.18,14.61h0c-5.35,14.88-15.68,24.97-27.55,24.97-5.45,0-10.57-2.12-15.04-5.87-3.18-15.65-6.78-31.91-10.93-47.91-1.04-4.05-2.13-8.08-3.25-12.08-1.39-4.98-2.84-9.91-4.35-14.77-2.64-8.48-5.45-16.74-8.48-24.63-12.51-32.63-28.52-58.99-49.48-69-12.62-6.03-27.04-6.13-43.56,1.89-39.36,19.12-69.8,28.54-92.81,32.07-58.22,8.93-68.93-19.82-56.32-24.7Z",
    style: {
      fill: "#4e9ed7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.67,173.58h0c-5.35,14.88-15.68,24.97-27.55,24.97-5.45,0-10.57-2.12-15.04-5.87-3.18-15.65-6.78-31.91-10.93-47.91-1.04-4.05-2.13-8.08-3.25-12.08-1.39-4.98-2.84-9.91-4.35-14.77-2.64-8.48-5.45-16.74-8.48-24.63-9.34-24.36-20.62-45.22-34.47-58.4,0,0-.01-.02-.02-.03-4.69-4.47-9.68-8.05-14.99-10.58-12.62-6.03-27.04-6.13-43.56,1.89-39.36,19.12-69.8,28.54-92.81,32.07-58.22,8.93-68.93-19.82-56.32-24.7,8.39-3.25,60.23-24.47,117.84-31.37,26.38-3.16,53.96-3.32,79.15,2.61,35.02,8.25,65.4,28.29,81.43,68.45,3.78,9.47,7.51,19.45,11.16,29.78,3.19,9.03,6.32,18.32,9.36,27.76h0c2.98,9.3,5.87,18.73,8.64,28.2,1.43,4.86,2.82,9.74,4.18,14.61Z",
    style: {
      fill: "url(#d)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.57,91.78c3.99-3.07,19.46-15.35,41.66-29.58,20.55-3.15,47.03-11.01,80.49-26.27,4-1.83,8.11-3.77,12.32-5.81,6.23-3.03,12.16-4.89,17.81-5.73,9.33-1.38,17.89,.08,25.76,3.83-10.12-.68-20.25,2.08-30.28,9.17-2.23,1.57-4.47,3.37-6.69,5.39-26.08,23.67-48.38,39.69-67.09,50.18-63.33,35.51-85.51,7.66-73.97-1.2Z",
    style: {
      fill: "url(#e)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.76,131.7c1.53-3.8,6.53-16.77,14.77-34.19,14.73-8.26,31.68-19.94,50.94-36.08,5.21-4.37,10.59-9.06,16.14-14.1,1.02-.93,2.05-1.81,3.07-2.65,1.21-.98,2.41-1.89,3.62-2.74-.95,2.62-1.91,5.18-2.87,7.67-11.98,31.16-24.35,52.61-35.85,66.99-30.28,37.87-54.54,26.77-49.83,15.09Z",
    style: {
      fill: "url(#f)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.59,125.28c11.51-14.38,23.88-35.83,35.85-66.99,13.7,95.62-28.45,106.37-31.53,90.6-.59-3.03-2.38-11.48-4.33-23.61Z",
    style: {
      fill: "url(#g)",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.67,173.58h0c-5.35,14.88-15.68,24.97-27.55,24.97-5.45,0-10.57-2.12-15.04-5.87-3.18-15.65-6.78-31.91-10.93-47.91-1.04-4.05-2.13-8.08-3.25-12.08-1.39-4.98-2.84-9.91-4.35-14.77-2.64-8.48-5.45-16.74-8.48-24.63-9.34-24.36-20.62-45.22-34.47-58.4,0,0-.01-.02-.02-.03C481.98,10.7,414.74,2.17,414.74,2.17c26.38-3.16,53.96-3.32,79.15,2.61,35.02,8.25,65.4,28.29,81.43,68.45,3.78,9.47,7.51,19.45,11.16,29.78,3.19,9.03,6.32,18.32,9.36,27.76h0c2.98,9.3,5.87,18.73,8.64,28.2,1.43,4.86,2.82,9.74,4.18,14.61Z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593.55,282.53c-12.23,4.73-116.79,47.66-196.99,28.75-35.02-8.25-65.4-28.29-81.43-68.45-3.78-9.47-7.51-19.45-11.16-29.78-3.19-9.03-6.32-18.32-9.36-27.76h0c-2.98-9.3-5.87-18.73-8.64-28.2-1.43-4.86-2.82-9.74-4.18-14.61h0c5.35-14.88,15.68-24.97,27.55-24.97,5.45,0,10.57,2.12,15.04,5.87,3.18,15.65,6.78,31.91,10.93,47.91,1.04,4.05,2.13,8.08,3.25,12.08,1.39,4.98,2.84,9.91,4.35,14.77,2.64,8.48,5.45,16.74,8.48,24.63,12.51,32.63,28.52,58.99,49.48,69,12.62,6.03,27.04,6.13,43.56-1.89,39.36-19.12,69.8-28.54,92.81-32.07,58.22-8.93,68.93,19.82,56.32,24.7Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.88,224.29c-3.99,3.07-19.46,15.35-41.66,29.58-20.55,3.15-47.03,11.01-80.49,26.27-4,1.83-8.11,3.77-12.32,5.81-6.23,3.03-12.16,4.89-17.81,5.73-9.33,1.38-17.89-.08-25.76-3.83,10.12,.68,20.25-2.08,30.28-9.17,2.23-1.57,4.47-3.37,6.69-5.39,26.08-23.67,48.38-39.69,67.09-50.18,63.33-35.51,85.51-7.66,73.97,1.2Z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.69,184.37c-1.53,3.8-6.53,16.77-14.77,34.19-14.73,8.26-31.68,19.94-50.94,36.08-5.21,4.37-10.59,9.06-16.14,14.1-1.02,.93-2.05,1.81-3.07,2.65-1.21,.98-2.41,1.89-3.62,2.74,.95-2.62,1.91-5.18,2.87-7.67,11.98-31.16,24.35-52.61,35.85-66.99,30.28-37.87,54.54-26.77,49.83-15.09Z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.87,190.79c-11.51,14.38-23.88,35.83-35.85,66.99-13.7-95.62,28.45-106.37,31.53-90.6,.59,3.03,2.38,11.48,4.33,23.61Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.81,142.45h0c5.35-14.88,15.68-24.97,27.55-24.97,5.45,0,10.57,2.12,15.04,5.87,3.18,15.65,6.78,31.91,10.93,47.91,1.04,4.05,2.13,8.08,3.25,12.08,1.39,4.98,2.84,9.91,4.35,14.77,2.64,8.48,5.45,16.74,8.48,24.63,9.34,24.36,20.62,45.22,34.47,58.4,0,0,.01,.02,.02,.03,22.6,24.15,89.83,32.68,89.83,32.68-26.38,3.16-53.96,3.32-79.15-2.61-35.02-8.25-65.4-28.29-81.43-68.45-3.78-9.47-7.51-19.45-11.16-29.78-3.19-9.03-6.32-18.32-9.36-27.76h0c-2.98-9.3-5.87-18.73-8.64-28.2-1.43-4.86-2.82-9.74-4.18-14.61Z",
    style: {
      fill: "url(#m)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.97,399.88l-4.97,29.29H40.28l-2.03,12.28-15.23,92.33H58.85l17.26-104.61h40.27l4.97-29.29H4.97Z",
    style: {
      fill: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.26,432.04c-4.8,0-9.41,.49-13.8,1.44-24.07,5.18-41.41,24.03-45.83,50.34-5.49,32.43,10.98,51.78,43.15,51.78,27.99,0,47.86-13.33,54.93-34.26h-32.95c-.12,.22-.25,.43-.38,.65,0,0,0,.01-.01,.02-2.34,3.81-6.24,6.38-10.85,7.53-1.83,.46-3.77,.69-5.77,.69-.15,0-.3,0-.45-.01-5.45-.09-9.36-2.06-11.62-5.27-2-2.82-2.73-6.6-2.12-10.93,0,0,0-.01,0-.03,0-.03,0-.06,.01-.09,0-.06,.02-.13,.03-.23,0-.06,.01-.12,.03-.18,0-.01,0-.03,0-.04,.34-2.25,1.62-10.71,2.91-17.15,.36-1.82,.82-3.43,1.28-4.81,.49-1.89,1.24-3.63,2.22-5.19,.07-.12,.11-.18,.11-.18,3.42-5.4,9.42-8.7,15.97-8.7,8.89,0,14.38,6.01,13.08,14.65h-29.46l-4.62,19.88h64.16l1.31-8.37c5.23-31.91-10.98-51.53-41.32-51.53Z",
    style: {
      fill: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,462.64c15.95-3.14,28.25-14.65,30.86-29.29,2.14-12.82-2.65-22.75-14.09-28.35-6.76-3.32-15.86-5.13-27.23-5.13h-58.06l-22.23,133.91h63.03c29.03,0,49.69-15.95,53.36-37.92,2.46-14.77-4.25-25.67-15.58-29.95-.62-.24-1.26-.45-1.92-.64-.01,0-.03,0-.04-.01-.31-.09-.63-.18-.96-.26-.04-.01-.08-.02-.11-.03-.24-.06-.48-.13-.72-.18-2.08-.48-4.28-.77-6.57-.84v-.08l.26-1.23Zm-45.64,18.04l.03-.14,.63-4.04h.05l5.5-32.49,.03-.15,.84-5.15h0l1.68-10.33h15.43c8.89,0,14.9,4.44,13.6,12.81-1.31,8.11-8.89,12.82-18.3,12.82h-13.84l-3.61,22.49h16.15c1.04,0,2.04,.04,2.98,.14,.53,.04,1.04,.11,1.55,.19,3.97,.61,6.96,2.09,8.83,4.36t0,0c2.02,2.44,2.76,5.79,2.06,9.95-1.31,8.89-8.37,13.6-20.4,13.6h-17l3.79-24.07Z",
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766,475.2c4.18-26.15-11.51-43.16-41.06-43.16-32.69,0-55.71,20.92-60.68,51.78-5.23,30.87,10.72,51.78,43.41,51.78,29.82,0,50.74-17,55.71-43.67h-33.47c-2.61,10.46-9.16,16.21-17.26,16.21-9.41,0-14.13-8.11-11.51-24.58,2.61-16.48,10.2-24.59,19.88-24.59,7.84,0,12.29,5.76,11.51,16.22h33.48Z",
    style: {
      fill: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.22,429.18l-16.97,104.31H59.07l14.45-88.6c-1.97-10.39-8.95-16.63-17.75-16.63-9.45,0-15.55,.92-15.55,.92Z",
    style: {
      fill: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.68,452.11c-4.32-11.93-18.36-20.06-39.79-20.06-30.08,0-47.6,15.7-51.78,34h33.22c1.83-6.28,7.06-9.12,13.86-9.16,14.36-.06,10.47,15.82,10.1,19.23-.6,5.51-7.45,43.78-7.67,44.61,0,0,0,.01,0,.02l-2.17,13.04h33.74l11.51-68.78c.78-4.61,.41-8.96-1.01-12.89Zm-41.59,50.21c-1.09,3.6-2.66,11.66-12.39,18.9-2.82,2.11-6.33,4.15-10.71,5.99-13.97,5.86-34.56,4.4-37.8-17.59-1.44,17.44,10.25,25.74,28.18,25.74,7.92,0,14.97-1.63,21.04-5.42,3.91-2.43,7.41-5.76,10.49-10.11,2.27-8.46,1.89-14.22,1.19-17.51Zm-15.4-18.46c-8.53,3.85-16.11,7.93-15.24,15.7,.87,7.89,5.87,10.48,6.26,10.67-1.51-1.47-2.19-3.59-1.8-6.26,.72-4.75,4.45-8.42,11.6-10.04,.72-.16,1.47-.31,2.26-.43,2.49-.45,4.88-.9,7.11-1.4,2.38-.53,4.48-1.89,5.96-3.82l.03-.04c4.83-6.32,5.61-17.46,5.69-22.78-.36,9.62-11.78,13.84-21.86,18.39Z",
    style: {
      fill: "url(#s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.44,499.56c.87,7.89,5.87,10.48,6.26,10.67,0,0,0,0,.01,0,1.59,1.55,4.12,2.37,7.34,2.37,6.81,0,13.98-3.69,17.03-10.29-1.41,4.64-3.62,16.72-23.1,24.89-13.97,5.86-34.56,4.4-37.8-17.59,.09-1.14,.24-2.33,.45-3.56,3.66-21.97,21.18-30.34,42.11-31.91,16.79-1.29,23.63-3.09,24.8-8.68-.66,17.75-38.99,17.12-37.11,34.09Z",
    style: {
      fill: "url(#t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.89,519.83c-7.84,11.12-18.51,15.53-31.53,15.53-17.92,0-29.62-8.29-28.18-25.74,3.24,21.99,23.83,23.44,37.8,17.59,19.48-8.17,21.69-20.25,23.1-24.89,.69,3.29,1.07,9.05-1.19,17.51Z",
    style: {
      fill: "url(#u)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.89,519.83c-3.07,4.35-6.57,7.69-10.49,10.11l-.7-8.72c9.72-7.24,11.29-15.3,12.39-18.9,.69,3.29,1.07,9.05-1.19,17.51Z",
    style: {
      fill: "url(#v)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.49,466.32c0,.09-.03,.18-.04,.27-.02,.19-.05,.38-.08,.56-.02,.11-.04,.21-.07,.31-.03,.16-.07,.33-.11,.49-.03,.11-.06,.22-.09,.33-.04,.15-.09,.3-.14,.45-.04,.11-.08,.22-.12,.33-.05,.14-.11,.28-.16,.42-.05,.11-.09,.22-.14,.32-.06,.13-.12,.27-.19,.4-.05,.11-.11,.21-.17,.32-.07,.13-.14,.26-.22,.38-.06,.1-.12,.21-.19,.31-.08,.12-.16,.24-.24,.37-.07,.1-.14,.2-.21,.3-.09,.12-.17,.24-.26,.35-.07,.1-.15,.2-.23,.29-.09,.12-.19,.23-.29,.35-.08,.09-.16,.19-.24,.28-.1,.11-.21,.23-.32,.34-.08,.09-.17,.18-.25,.26-.13,.13-.26,.25-.39,.38-.16,.15-.31,.29-.48,.44-.12,.11-.24,.21-.36,.32-.11,.1-.23,.19-.34,.28-.11,.09-.22,.18-.33,.27-.12,.1-.24,.19-.37,.28-.11,.08-.22,.17-.33,.25-.13,.09-.26,.18-.39,.28-.11,.08-.23,.16-.34,.24-.13,.09-.27,.18-.4,.27-.12,.08-.23,.16-.35,.23-.14,.09-.28,.18-.42,.27-.12,.08-.24,.15-.36,.23-.14,.09-.28,.17-.43,.26-.13,.07-.25,.15-.38,.22-.14,.08-.29,.17-.43,.25-.13,.08-.27,.15-.4,.23-.14,.08-.28,.16-.42,.23-.15,.08-.3,.16-.45,.24-.13,.07-.27,.14-.4,.21-.17,.09-.35,.18-.52,.27-.11,.06-.23,.12-.34,.17-.24,.12-.48,.24-.73,.36-.05,.02-.09,.05-.14,.07-2.77,1.35-5.7,2.6-8.54,3.88h0c-8.53,3.85-16.11,7.93-15.24,15.7,.87,7.89,5.87,10.48,6.26,10.67-1.51-1.47-2.19-3.59-1.8-6.26,.73-4.83,4.59-8.54,11.98-10.12,.16-.04,.33-.07,.5-.1,.45-.09,.91-.17,1.38-.24,2.49-.45,4.88-.9,7.11-1.4,2.38-.53,4.48-1.89,5.96-3.82l.03-.04c4.83-6.32,5.61-17.46,5.69-22.78-.01,.29-.03,.57-.06,.85Z",
    style: {
      fill: "url(#w)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.69,465l-11.51,68.78h-33.74l2.17-13.04s0-.01,0-.02c.22-.82,7.07-39.1,7.67-44.61,.36-3.41,4.26-19.29-10.1-19.23-6.81,.03-12.03,2.88-13.86,9.16,.51-2.24,5.57-21.96,25.71-24.93,16.49-2.43,27.82,1.14,32.64,10.99,1.43,3.93,1.79,8.29,1.01,12.89Z",
    style: {
      fill: "url(#x)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M652.85,452.74c-4.32-11.93-18.36-20.06-39.79-20.06-30.08,0-47.6,15.7-51.78,34h33.22c1.83-6.28,7.06-9.12,13.86-9.16,14.36-.06,10.47,15.82,10.1,19.23-.6,5.51-7.45,43.78-7.67,44.61,0,0,0,.01,0,.02l-2.17,13.04h33.74l11.51-68.78c.78-4.61,.41-8.96-1.01-12.89Zm-41.59,50.21c-1.09,3.6-2.66,11.66-12.39,18.9-2.82,2.11-6.33,4.15-10.71,5.99-13.97,5.86-34.56,4.4-37.8-17.59-1.44,17.44,10.25,25.74,28.18,25.74,7.92,0,14.97-1.63,21.04-5.42,3.91-2.43,7.41-5.76,10.49-10.11,2.27-8.46,1.89-14.22,1.19-17.51Zm-15.4-18.46c-8.53,3.85-16.11,7.93-15.24,15.7,.87,7.89,5.87,10.48,6.26,10.67-1.51-1.47-2.19-3.59-1.8-6.26,.72-4.75,4.45-8.42,11.6-10.04,.72-.16,1.47-.31,2.26-.43,2.49-.45,4.88-.9,7.11-1.4,2.38-.53,4.48-1.89,5.96-3.82l.03-.04c4.83-6.32,5.61-17.46,5.69-22.78-.36,9.62-11.78,13.84-21.86,18.39Z",
    style: {
      fill: "url(#y)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.62,500.18c.87,7.89,5.87,10.48,6.26,10.67,0,0,0,0,.01,0,1.59,1.55,4.12,2.37,7.34,2.37,6.81,0,13.98-3.69,17.03-10.29-1.41,4.64-3.62,16.72-23.1,24.89-13.97,5.86-34.56,4.4-37.8-17.59,.09-1.14,.24-2.33,.45-3.56,3.66-21.97,21.18-30.34,42.11-31.91,16.79-1.29,23.63-3.09,24.8-8.68-.66,17.75-38.99,17.12-37.11,34.09Z",
    style: {
      fill: "url(#a`)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.06,520.45c-7.84,11.12-18.51,15.53-31.53,15.53-17.92,0-29.62-8.29-28.18-25.74,3.24,21.99,23.83,23.44,37.8,17.59,19.48-8.17,21.69-20.25,23.1-24.89,.69,3.29,1.07,9.05-1.19,17.51Z",
    style: {
      fill: "url(#aa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.06,520.45c-3.07,4.35-6.57,7.69-10.49,10.11l-.7-8.72c9.72-7.24,11.29-15.3,12.39-18.9,.69,3.29,1.07,9.05-1.19,17.51Z",
    style: {
      fill: "url(#ab)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.66,466.95c0,.09-.03,.18-.04,.27-.02,.19-.05,.38-.08,.56-.02,.11-.04,.21-.07,.31-.03,.16-.07,.33-.11,.49-.03,.11-.06,.22-.09,.33-.04,.15-.09,.3-.14,.45-.04,.11-.08,.22-.12,.33-.05,.14-.11,.28-.16,.42-.05,.11-.09,.22-.14,.32-.06,.13-.12,.27-.19,.4-.05,.11-.11,.21-.17,.32-.07,.13-.14,.26-.22,.38-.06,.1-.12,.21-.19,.31-.08,.12-.16,.24-.24,.37-.07,.1-.14,.2-.21,.3-.09,.12-.17,.24-.26,.35-.07,.1-.15,.2-.23,.29-.09,.12-.19,.23-.29,.35-.08,.09-.16,.19-.24,.28-.1,.11-.21,.23-.32,.34-.08,.09-.17,.18-.25,.26-.13,.13-.26,.25-.39,.38-.16,.15-.31,.29-.48,.44-.12,.11-.24,.21-.36,.32-.11,.1-.23,.19-.34,.28-.11,.09-.22,.18-.33,.27-.12,.1-.24,.19-.37,.28-.11,.08-.22,.17-.33,.25-.13,.09-.26,.18-.39,.28-.11,.08-.23,.16-.34,.24-.13,.09-.27,.18-.4,.27-.12,.08-.23,.16-.35,.23-.14,.09-.28,.18-.42,.27-.12,.08-.24,.15-.36,.23-.14,.09-.28,.17-.43,.26-.13,.07-.25,.15-.38,.22-.14,.08-.29,.17-.43,.25-.13,.08-.27,.15-.4,.23-.14,.08-.28,.16-.42,.23-.15,.08-.3,.16-.45,.24-.13,.07-.27,.14-.4,.21-.17,.09-.35,.18-.52,.27-.11,.06-.23,.12-.34,.17-.24,.12-.48,.24-.73,.36-.05,.02-.09,.05-.14,.07-2.77,1.35-5.7,2.6-8.54,3.88h0c-8.53,3.85-16.11,7.93-15.24,15.7,.87,7.89,5.87,10.48,6.26,10.67-1.51-1.47-2.19-3.59-1.8-6.26,.73-4.83,4.59-8.54,11.98-10.12,.16-.04,.33-.07,.5-.1,.45-.09,.91-.17,1.38-.24,2.49-.45,4.88-.9,7.11-1.4,2.38-.53,4.48-1.89,5.96-3.82l.03-.04c4.83-6.32,5.61-17.46,5.69-22.78-.01,.29-.03,.57-.06,.85Z",
    style: {
      fill: "url(#ac)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.86,465.63l-11.51,68.78h-33.74l2.17-13.04s0-.01,0-.02c.22-.82,7.07-39.1,7.67-44.61,.36-3.41,4.26-19.29-10.1-19.23-6.81,.03-12.03,2.88-13.86,9.16,.51-2.24,5.57-21.96,25.71-24.93,16.49-2.43,27.82,1.14,32.64,10.99,1.43,3.93,1.79,8.29,1.01,12.89Z",
    style: {
      fill: "url(#ad)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "249.04 506.48 248.14 511.97 248.13 511.97 249.04 506.48",
    style: {
      fill: "url(#ae)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M230.66,399.88l-22.23,133.91h36.09l3.61-21.81h0l.9-5.49,.19-1.14,6.35-38.25h0l1.08-6.47,.3-1.81,9.8-58.93h-36.09Zm55.38,77.55l41.39-44.07h-40.54l-25.24,29.89c-3.02,3.58-4.75,8.06-4.93,12.73l-.65,17.66c-.13,3.37,.48,6.74,1.78,9.86l1.92,4.62,10.64,25.66h41.33l-25.67-56.29-.03-.07Z",
    style: {
      fill: "url(#af)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.74,533.78h-41.33l-10.64-25.66c.11-1.12,.23-2.31,.37-3.54,2.14-18.39,16.78-24.84,25.93-27.09l25.67,56.29Z",
    style: {
      fill: "url(#ag)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M793.68,399.88l-22.23,133.91h36.09l3.61-21.81h0l.9-5.49,.19-1.14,6.35-38.25h0l1.08-6.47,.3-1.81,9.8-58.93h-36.09Zm55.38,77.55l41.39-44.07h-40.54l-25.24,29.89c-3.02,3.58-4.75,8.06-4.93,12.73l-.65,17.66c-.13,3.37,.48,6.74,1.78,9.86l1.92,4.62,10.64,25.66h41.33l-25.67-56.29-.03-.07Z",
    style: {
      fill: "url(#ah)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.76,533.78h-41.33l-10.64-25.66c.11-1.12,.23-2.31,.37-3.54,2.14-18.39,16.78-24.84,25.93-27.09l25.67,56.29Z",
    style: {
      fill: "url(#ai)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.7,501.35c-7.06,20.92-26.94,34.26-54.93,34.26-32.17,0-48.64-19.35-43.15-51.78,4.42-26.32,21.76-45.16,45.83-50.34-30.91,12.66-30.99,47.55-14.57,66.7,1.63,1.9,3.22,3.47,4.79,4.78,2.27,3.22,6.18,5.18,11.62,5.27,2.24,.19,4.32-.1,6.21-.68,4.61-1.15,8.51-3.72,10.85-7.53,0,0,.01-.01,.01-.02,.3-.35,.45-.56,.45-.56l.68-.09h32.2Z",
    style: {
      fill: "url(#aj)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.47,492.01c-6.28,29.53-27.99,43.68-55.98,43.68-32.17,0-48.64-19.35-43.15-51.78,4.42-26.32,21.76-45.16,45.83-50.34-45.36,27.03-8.6,68.45-7.03,69.76,2.27,3.22,6.67,6.17,15.08,3.77,8.8-2.51,11.94-15.08,11.94-15.08h33.3Z",
    style: {
      fill: "url(#ak)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.94,433.36c-2.61,14.64-14.9,26.15-30.86,29.29l-.26,1.31c3.73,.11,7.2,.79,10.32,1.96-10,3.36-22.78,7.57-32.99,10.92-1.39-.22-2.9-.33-4.52-.33h-16.15l3.61-22.49h13.84c9.41,0,17-4.71,18.3-12.82,1.31-8.37-4.71-12.81-13.6-12.81h-15.43s.13-10.52,16.47-19.94c9.51-5.48,23.77-8.31,37.18-3.44,11.44,5.61,16.22,15.53,14.09,28.35Z",
    style: {
      fill: "url(#al)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.71,495.86c-3.66,21.97-24.32,37.92-53.36,37.92h-22.04c18.48-4.32,40.56-13.27,42.55-29.2,1.26-10.05-3.66-20.15-6.88-23.38t0,0c-1.88-2.27-4.87-3.75-8.83-4.36-.5-.08-1.02-.14-1.55-.19,3.82-5.31,11.65-13.18,24.23-12.77,2.05,.06,4.24,.35,6.56,.91,.24,.05,.48,.11,.72,.18,.04,.01,.08,.02,.11,.03,.33,.08,.65,.18,.96,.26,.01,0,.03,0,.04,.01,.65,.19,1.29,.4,1.92,.64,11.33,4.28,18.03,15.18,15.58,29.95Z",
    style: {
      fill: "url(#am)"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVertical);
export default __webpack_public_path__ + "static/media/logo-vertical.ff2182840e728fa3854dab76cd0c00a2.svg";
export { ForwardRef as ReactComponent };